@if (this.analysisStateService.configurations.isLoading()) {
  <div class="flex flex-row gap-3 items-center">
    <mat-progress-spinner
      mode="indeterminate"
      [diameter]="24"
      color="primary"
    />
    <p class="text-xs text-content-interactive-subdued">
      {{ 'ANALYSIS.ERROR_CONFIGURATIONS_LOADING' | translate }}
    </p>
  </div>
} @else {
  @if (this.analysisStateService.configurations.error()) {
    <pm-loading-failed-hint />
  } @else {
    @let configurations = this.analysisStateService.configurations.value();

    <!-- case: no configurations exist -->
    @if (!configurations || configurations.length === 0) {
      <pm-button
        variant="primary"
        text="ANALYSIS.CREATE_CONFIGURATION.TITLE"
        [icon]="plusIcon"
        (handleClick)="handleCreateErrorConfiguration()"
      />
    } @else {
      <!-- case: configurations exist -->
      <pm-analysis-content [analysisConfigurations]="configurations" />
    }
  }
}
